// extracted by mini-css-extract-plugin
export var box = "PageFooter-module--box--7d7be";
export var content = "PageFooter-module--content--b7f9c";
export var heading = "PageFooter-module--heading--2af40";
export var links = "PageFooter-module--links--29779";
export var logo = "PageFooter-module--logo--8ca95";
export var wrapper = "PageFooter-module--wrapper--62a01";